import { content as terminContent } from '../../../utils';

export const content = {
  ...terminContent,
  draggableId: 'generellerKommentar',
  heading: 'Kommentar',
} as const;
